import ErrorBanner, { ErrorBannerAlign, ErrorBannerVariant } from '../../../components/ErrorBanner';

export type AdminErrorBannerAlign = ErrorBannerAlign;
export type AdminErrorBannerVariant = ErrorBannerVariant;

export default ErrorBanner;
